<template>
  <div v-if="topic.votetype == 'nnp'">
    <div class="vote-stat" v-if="voteInfo.vote_nnp_pro > 0" :title="nnpProText">
      <span type="button" v-tooltip.bottom="nnpProText">
        <font-awesome-icon :icon="['far', 'thumbs-up']" aria-hidden="true" />
        {{ voteInfo.vote_nnp_pro }}
      </span>
      <span class="visually-hidden">{{ nnpProText }}</span>
    </div>
    <div class="vote-stat" v-if="voteInfo.vote_nnp_con > 0" :title="nnpConText">
      <span type="button" v-tooltip.bottom="nnpConText">
        <font-awesome-icon :icon="['far', 'thumbs-down']" aria-hidden="true" />
        {{ voteInfo.vote_nnp_con }}
      </span>
      <span class="visually-hidden">{{ nnpConText }}</span>
    </div>
    <div class="vote-stat" v-if="voteInfo.vote_nnp_con > 0 || voteInfo.vote_nnp_pro > 0" :title="nnpSummaryText">
      <span type="button" v-tooltip.bottom="nnpSummaryText">
        <font-awesome-icon :icon="['far', 'chart-bar']" aria-hidden="true" />
        {{ voteInfo.votesum }}
      </span>
      <span class="visually-hidden">{{ nnpSummaryText }}</span>
    </div>
  </div>
  <div v-else-if="topic.votetype == 'support'">
    <div class="vote-stat" :title="supportVotesumText">
      <span type="button" v-tooltip.bottom="supportVotesumText">
        <font-awesome-icon :icon="['far', 'thumbs-up']" aria-hidden="true" />
        {{ voteInfo.votesum }}
      </span>
      <span class="visually-hidden">{{ supportVotesumText }}</span>
    </div>
  </div>
  <div v-else-if="topic.votetype == 'stars'">
    <vote-stars :voteStatus="voteResult" :canVote="false" />
  </div>
</template>

<script>
import { computed, ref, toRefs } from '@vue/runtime-core';
import useConverter from '@/composables/general/useConverter';
import VoteStars from '@/components/discuss/thought/VoteStars.vue';

export default {
  name: 'VoteStats',
  props: {
    topic: {
      required: true,
      type: Object,
    },
    voteInfo: {
      required: true,
      type: Object,
    },
  },
  setup(props, context) {
    const { voteInfo, topic } = toRefs(props);
    const { toBool } = useConverter();

    const supportVotesumText = computed(() => {
      return voteInfo.value.votesum == 1
        ? ' 1 Teilnehmer unterstützt diesen Beitrag'
        : Math.ceil(voteInfo.value.votesum) + ' Teilnehmende unterstützen diesen Beitrag';
    });
    const nnpProText = computed(() => {
      return voteInfo.value.vote_nnp_pro == 1
        ? ' 1 Teilnehmer unterstützt diesen Beitrag'
        : Math.ceil(voteInfo.value.vote_nnp_pro) + ' Teilnehmende unterstützen diesen Beitrag';
    });
    const nnpConText = computed(() => {
      return voteInfo.value.vote_nnp_con == 1
        ? '1 Teilnehmer lehnt diesen Beitrag ab'
        : Math.ceil(voteInfo.value.vote_nnp_con) + ' Teilnehmende lehnen diesen Beitrag ab';
    });
    const nnpSummaryText = computed(() => {
      return toBool(topic.value.new_votes)
        ? 'Zwischenergebnis der Abstimmung zu diesem Beitrag: ' + voteInfo.value.votesum
        : 'Abstimmungsergebnis zu diesem Beitrag: ' + voteInfo.value.votesum;
    });
    const voteResult = computed(() => {
      return voteInfo.value.votesum / voteInfo.value.votecount;
    });

    return {
      supportVotesumText,
      nnpProText,
      nnpConText,
      nnpSummaryText,
      voteResult,
    };
  },
  components: {
    VoteStars,
  },
};
</script>

<style scoped lang="scss">
.vote-stat {
  display: inline-block;
  margin-right: 0.8em;
}
</style>
